"use client";

/** Grid-only skeleton — used as Suspense fallback inside CoursesList */
export function CoursesGridSkeleton() {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {Array.from({ length: 6 }).map((_, i) => (
                <div
                    key={i}
                    className="bg-white rounded-2xl border border-gray-200 overflow-hidden flex flex-col"
                >
                    {/* Image placeholder */}
                    <div className="aspect-[4/3] bg-gray-100 animate-pulse relative overflow-hidden">
                        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent skeleton-shimmer" />
                    </div>

                    <div className="p-4 sm:p-6 flex-1 flex flex-col">
                        {/* Title */}
                        <div className="flex justify-between items-start mb-2">
                            <div className="h-5 w-full max-w-[85%] bg-gray-200 rounded-lg animate-pulse" />
                        </div>

                        {/* Progress bar placeholder */}
                        <div className="w-full bg-gray-100 rounded-full h-1.5 mb-3 sm:mb-4 animate-pulse" />
                        <div className="h-3 w-16 bg-gray-100 rounded ml-auto mb-4 animate-pulse" />

                        {/* Description lines */}
                        <div className="space-y-2 mb-4 sm:mb-6 flex-1">
                            <div className="h-3 w-full bg-gray-100 rounded animate-pulse" />
                            <div className="h-3 w-full bg-gray-100 rounded animate-pulse" />
                            <div className="h-3 w-[80%] bg-gray-100 rounded animate-pulse" />
                        </div>

                        {/* Footer: meta + button */}
                        <div className="mt-auto flex items-center gap-2 mb-3 sm:mb-4">
                            <div className="h-4 w-24 bg-gray-100 rounded animate-pulse" />
                        </div>
                        <div className="h-11 w-full bg-gray-200 rounded-xl animate-pulse" />
                    </div>
                </div>
            ))}
        </div>
    );
}

/** Full-page skeleton — used by loading.tsx for initial page navigation */
export default function CoursesListSkeleton() {
    return (
        <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8 py-4 sm:py-6 lg:py-8 animate-in fade-in duration-200">
            <div className="flex flex-col gap-4 mb-6 sm:mb-8">
                {/* Header skeleton */}
                <div>
                    <div className="h-8 sm:h-9 w-48 sm:w-56 bg-gray-200 rounded-lg mb-2 animate-pulse" />
                    <div className="h-4 w-72 sm:w-80 bg-gray-100 rounded-md animate-pulse" />
                </div>

                {/* Search and filters skeleton */}
                <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3">
                    <div className="h-10 flex-1 max-w-md bg-gray-100 rounded-lg animate-pulse" />
                    <div className="flex bg-gray-100 p-1 rounded-lg w-full sm:w-auto sm:min-w-[200px]">
                        <div className="h-9 flex-1 bg-gray-200/80 rounded-md animate-pulse mx-0.5" />
                        <div className="h-9 flex-1 bg-gray-100 rounded-md animate-pulse mx-0.5" />
                        <div className="h-9 flex-1 bg-gray-100 rounded-md animate-pulse mx-0.5" />
                    </div>
                </div>
            </div>

            <CoursesGridSkeleton />
        </div>
    );
}
